import React, { useEffect, useState } from "react";
import isEqual from "lodash.isequal";
import { useDispatch, useSelector } from "react-redux";
import { useProjectState } from "../../../../context/stateContext";
import CreateReservationNewModal from "../ReservationTablesSubComponents/CreateReservationNewModal";
import EditReservationNewModal from "../ReservationTablesSubComponents/EditReservationNewModal";
import reservationsActions from "../../../../redux/reservations/actions";
import ReservationViewTable from "./ReservationViewTable";

const { getTablesAndReservationPerRegion } = reservationsActions;

const ReservationsTableViewsComponent = ({
  regionId,
  date,
  showOrHideColumns,
}) => {
  const { setSelectedTimeForReservation, setClickedTableForReservation } =
    useProjectState();

  const dispatch = useDispatch();

  const { tablesWithReservations, reservations } = useSelector(
    (state) => state.restaurantReservationsReducer
  );

  const [tablesWithReservationsState, setTablesWithReservationsState] =
    useState(tablesWithReservations);

  // When we update the reservation from /reservation-overview from here we make one more request for fresh data
  // We use reservations not tablesWithReservations because in redux when we edin we change reservations, but its work in the same way
  useEffect(() => {
    if (!isEqual(tablesWithReservationsState, reservations)) {
      // Get all Reservation Tables
      setTablesWithReservationsState(reservations);
      dispatch(
        getTablesAndReservationPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: regionId,
          date: date.format("YYYY-MM-DD"),
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservations]);

  return (
    <>
      <CreateReservationNewModal regionId={regionId} date={date} />
      <EditReservationNewModal date={date} />
      <div>
        <ReservationViewTable
          showOrHideColumns={showOrHideColumns}
          setSelectedTimeForReservation={setSelectedTimeForReservation}
          setClickedTableForReservation={setClickedTableForReservation}
        />
      </div>
    </>
  );
};

export default ReservationsTableViewsComponent;
